import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

/*
 * Props.
 */

interface FormError {
  key: string;
  label: ReactNode;
}

interface EditorErrorListProps {
  errors: ReadonlyArray<FormError>;
}

/*
 * Styles.
 */

const StyledWarningListUl = styled.ul`
  padding-left: 21px;
  margin: 8px 8px 8px 0;
`;

const StyledWarningListItemLi = styled.li`
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

/*
 * Component.
 */

export const EditorErrorList: FC<EditorErrorListProps> = (props) => {
  const {errors} = props;

  return (
    <StyledWarningListUl>
      {errors.map(({key, label}) => (
        <StyledWarningListItemLi key={key}>{label}</StyledWarningListItemLi>
      ))}
    </StyledWarningListUl>
  );
};
